import React from 'react';
import { createStyles, ListItemText, ListItem, Theme, withStyles, WithStyles } from '@material-ui/core';
import { Typography, Checkbox } from 'components/v2';
import { ListNodes } from '../fragments';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    infiniteScrollWrapper: {
      flex: 1,
      minHeight: 40,
      maxHeight: 320,
      overflow: 'auto',
    },
    listItemText: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: 0,
    },
    listItemTextName: {
      flex: 1,
      marginRight: unit * 2,
    },
    buttonWithoutHover: {
      '&:hover': {
        backgroundColor: 'initial',
      },
      '&:focus': {
        backgroundColor: 'initial',
      },
    },
    checkboxRoot: {
      paddingTop: 3,
      paddingBottom: 3,
      marginLeft: -1 * unit * 2.5,
    },
  });

export interface FilterByMeProps extends WithStyles<typeof styles> {
  className?: string;
  isChecked?: boolean;
  onCheck?: (value: boolean) => void;
}

const FilterByMe: React.FC<FilterByMeProps> = ({ classes, className, isChecked, onCheck, ...rest }) => (
  <div className={classes.infiniteScrollWrapper}>
    <ListNodes {...rest}>
      <ListItem
        button
        classes={{
          root: className,
          button: classes.buttonWithoutHover,
        }}
        selected={isChecked}
        onClick={() => {
          if (onCheck) onCheck(!isChecked);
        }}
        {...rest}
      >
        <Checkbox
          classes={{ root: classes.checkboxRoot }}
          color="primary"
          size="small"
          tabIndex={-1}
          disableRipple
          checked={isChecked}
          onClick={(event) => event.stopPropagation()}
          onChange={() => {
            if (onCheck) onCheck(!isChecked);
          }}
          inputProps={{
            'data-lh-id': 'filter-facilities-list-item-node-checkbox',
          }}
        />
        <ListItemText
          className={classes.listItemText}
          disableTypography
          primary={
            <Typography className={classes.listItemTextName} variant="body1Bold" color="primary">
              Me
            </Typography>
          }
        />
      </ListItem>
    </ListNodes>
  </div>
);

export default withStyles(styles)(FilterByMe);
